import React from "react";
import { ProducerPlaybackTimeCellTemplate } from "themes/common/components/producer";

function ProducerPlaybackTimeCell(props) {
    return <ProducerPlaybackTimeCellTemplate {...props} />;
}

export default ProducerPlaybackTimeCell;
